import { ExpandLess, ExpandMore, InfoOutlined, OpenInNew } from '@mui/icons-material';
import { Alert, Box, Collapse, Link, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import s from './CalDavInstructions.module.scss';

type CalDavInstructionsProps = {
  isConfigured: boolean;
};

export const CalDavInstructions: React.FC<CalDavInstructionsProps> = ({ isConfigured }) => {
  const [expanded, setExpanded] = useState(!isConfigured);

  useEffect(() => {
    setExpanded(!isConfigured);
  }, [isConfigured]);

  const toggleExpanded = () => setExpanded((prev) => !prev);

  return (
    <Box className={s.instructions}>
      <Alert
        severity="info"
        icon={<InfoOutlined />}
        sx={{ mb: expanded ? 2 : 0, cursor: 'pointer' }}
        onClick={toggleExpanded}
        action={expanded ? <ExpandLess /> : <ExpandMore />}
      >
        <Typography variant="body2" fontWeight={500} mb={expanded ? 0.5 : 0}>
          Для подключения нужен пароль для внешних приложений
        </Typography>
        {expanded && (
          <Typography variant="caption" color="text.secondary">
            Это не основной пароль от почты
          </Typography>
        )}
      </Alert>

      <Collapse in={expanded}>
        <Box className={s.instructions__steps}>
          <div className={s.instructions__step}>
            <span className={s.instructions__step_number}>1</span>
            <div className={s.instructions__step_content}>
              <Typography variant="body2" fontWeight={500}>
                Создайте пароль для внешних приложений
              </Typography>
              <Typography variant="caption" color="text.secondary" component="div">
                Перейдите в{' '}
                <Link
                  href="https://id.mail.ru/security"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.3 }}
                >
                  id.mail.ru/security
                  <OpenInNew sx={{ fontSize: 12 }} />
                </Link>
                , найдите раздел «Пароли для внешних приложений» и создайте новый пароль. Настройка
                доступа — Полный доступ к почте (CalDAV)
              </Typography>
            </div>
          </div>

          <div className={s.instructions__step}>
            <span className={s.instructions__step_number}>2</span>
            <div className={s.instructions__step_content}>
              <Typography variant="body2" fontWeight={500}>
                Введите данные ниже
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Логин — ваш email, пароль — созданный на предыдущем шаге
              </Typography>
            </div>
          </div>

          <div className={s.instructions__step}>
            <span className={s.instructions__step_number}>3</span>
            <div className={s.instructions__step_content}>
              <Typography variant="body2" fontWeight={500}>
                Выберите календари для синхронизации
              </Typography>
              <Typography variant="caption" color="text.secondary">
                После подключения отметьте календари, события из которых хотите видеть
              </Typography>
            </div>
          </div>
        </Box>
      </Collapse>
    </Box>
  );
};
